<script setup lang="ts">
import { computed } from "vue";

import GroupHoverCard from "@/components/group-hover-card.vue";
import { Badge } from "@/components/ui/badge";
import { mentionSegmentsFromText } from "@/lib/discussion-mentions";
import type { MentionableEntity } from "@/types";

interface Props {
  text: string;
  mentionables?: MentionableEntity[];
}

const props = withDefaults(defineProps<Props>(), {
  mentionables: () => [],
});

type Segment = { type: "text"; value: string } | { type: "mention"; value: string; entity: MentionableEntity };
const segments = computed<Segment[]>(() =>
  mentionSegmentsFromText(props.text, props.mentionables)
    .map((segment) => {
      if (segment.type === "text") return segment;
      return segment.entity ? { ...segment, entity: segment.entity } : { type: "text", value: segment.value };
    }),
);
</script>

<template>
  <template v-for="(segment, i) in segments" :key="i">
    <template v-if="segment.type === 'text'">{{ segment.value }}</template>
    <GroupHoverCard
      v-else-if="segment.entity.type === 'group'"
      :name="segment.entity.name"
      :members="segment.entity.members"
    >
      <Badge
        variant="secondary"
        class="inline-flex cursor-default rounded-full px-1.5 py-0 text-[inherit] font-semibold leading-snug align-baseline"
      >
        {{ segment.value }}
      </Badge>
    </GroupHoverCard>
    <Badge
      v-else
      variant="secondary"
      class="inline-flex rounded-full px-1.5 py-0 text-[inherit] font-semibold leading-snug align-baseline"
    >
      {{ segment.value }}
    </Badge>
  </template>
</template>
